import React from 'react';
import SelectFilter from '../../../../components/Select/SelectFilter';

const Select = (props) => (
  <SelectFilter
    dropdownProps={{
      colorIcon: 'rgba(226,93,52,1)'
    }}
    minWidth="150px"
    containerStyles={`.label{color:${
      props.colorLabel ? props.colorLabel : '#e25c32'
    };${
      props.fontSize && 'margin-bottom:' + Number(props.fontSize - 20) + 'px'
    }`}
    customStyles={{
      container: {
        marginTop: 5,
        height: 25,
        minHeight: 25
      },
      control: {
        border: 0,
        borderBottom: '1px solid rgba(134,142,150,0.3)',
        backgroundColor: 'transparent',
        height: '25px',
        minHeight: '25px',
        fontFamily: 'SilkSerifRegular'
      },
      valueContainer: {
        height: 25,
        paddingLeft: 0,
        marginLeft: 0,
        color: 'white'
      },
      singleValue: {
        color: 'white',
        fontFamily: 'SilkSerifRegular',
        fontSize: props.fontSize ? props.fontSize : '24px'
      },
      placeholder: {
        fontStyle: 'normal',
        color: 'white',
        opacity: 0.8
      },
      option: {
        backgroundColor: '#1a1f24',
        color: 'white',
        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.60)' },
        fontFamily: 'SilkSerifRegular'
      },
      menuList: {
        backgroundColor: 'rgba(0, 0, 0, 0.53)',
        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.53)' }
      }
    }}
    {...props}
  />
);

export default Select;
